import * as t from "io-ts";
import {LatLngCodec} from "./lat-lng";

export const RouteGeometryCodec = t.intersection([
  t.type({
    format: t.string,
  }),
  t.partial({
    encodedPolyline: t.string,
    coordinates: t.array(LatLngCodec)
  }),
]);

export type RouteGeometry = t.TypeOf<typeof RouteGeometryCodec>;
